import { Injectable } from '@angular/core';
import { fromJS } from 'immutable';
import { merger } from '../../utils/helpers/model.helper';
import { Settings } from './settings.model';
import {
  CompanySettings,
  ManualPaymentReceiptsEnabledEnum,
} from './sub-models/company-settings/company-settings.model';
import { PaymentsSettings } from './sub-models/company-settings/payments.model';
import { SettingsContent } from './sub-models/settings-content.model';

@Injectable()
export class SettingsDataBuilder {
  constructor() {}

  buildSettingsFromPaymentSettings(
    currentSettings: Settings,
    paymentSettings: PaymentsSettings
  ): Settings {
    const newSettingsProps = fromJS({
      [Settings.KEYS.CONTENT]: {
        [SettingsContent.KEYS.COMPANY_SETTINGS]: {
          [CompanySettings.KEYS.PAYMENTS]: paymentSettings,
        },
      },
    });

    return new Settings(merger(currentSettings, newSettingsProps));
  }

  buildSettingsWithUnderwritingUrl(
    currentSettings: Settings,
    underwritingUrl: string
  ): Settings {
    const newSettingsProps = fromJS({
      [Settings.KEYS.CONTENT]: {
        [SettingsContent.KEYS.COMPANY_SETTINGS]: {
          [CompanySettings.KEYS.PAYMENTS]: {
            [PaymentsSettings.KEYS.UNDERWRITING_URL]: underwritingUrl,
          },
        },
      },
    });

    return new Settings(merger(currentSettings, newSettingsProps));
  }

  buildPaymentReceiptsSettingsProps(toggleValue: boolean) {
    const manualPaymentReceiptsEnabled = toggleValue
      ? ManualPaymentReceiptsEnabledEnum.on
      : ManualPaymentReceiptsEnabledEnum.off;

    return fromJS({
      [SettingsContent.KEYS.COMPANY_SETTINGS]: {
        [CompanySettings.KEYS
          .MANUAL_PAYMENT_RECEIPTS_ENABLED]: manualPaymentReceiptsEnabled,
      },
    });
  }

  buildSettingsForMfa(
    currentSettings: Settings,
    mfaEnabled: boolean
  ): Settings {
    const newSettingsProps = fromJS({
      [Settings.KEYS.CONTENT]: {
        [SettingsContent.KEYS.COMPANY_SETTINGS]: {
          [CompanySettings.KEYS.MFA_ENABLED]: mfaEnabled,
        },
      },
    });

    return new Settings(merger(currentSettings, newSettingsProps));
  }
}
